import { z } from 'zod';

const baseSchema = z.object({
  email: z.string().email(),
  quantity: z.coerce.number().int().min(1),
});

const presetValueSchema = baseSchema.extend({
  value: z.number().refine((v) => v !== 0),
  custom_value: z.union([z.coerce.number(), z.literal(NaN)]).optional(),
});

/** `min`/`max` are major-unit currency (euros, dollars, ...) — custom_value is what the customer types into a currency input, not a minor-unit amount. */
export const createBuyGiftCardSchema = (min: number, max: number) => {
  const customValueSchema = baseSchema.extend({
    value: z.literal(0),
    custom_value: z.coerce.number().min(min).max(max),
  });

  return z.union([presetValueSchema, customValueSchema]);
};

export type BuyGiftCardForm = z.infer<ReturnType<typeof createBuyGiftCardSchema>>;
